module.exports = __webpack_public_path__ + "static/media/MobilityMadrid.9504a184.svg";